export default __webpack_public_path__ + "static/media/Design-UX-UI-EN.3f88937e.jpg";